export default __webpack_public_path__ + "static/1-594abd591058300fb8e05154f1039fd4.png";